import { render, staticRenderFns } from "./ManufacturerForm.vue?vue&type=template&id=271c16c6&"
import script from "./ManufacturerForm.vue?vue&type=script&lang=js&"
export * from "./ManufacturerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports